// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"X4UdjmUz"};